<div class="container">
  <owl-carousel-o [options]="liveOption" class="live-autoplay-slider">
    <ng-container
      *ngFor="
        let item of liveScores
          | liveScore: (_activated.params | async).sport || _sport.defaultSport
      "
    >
      <ng-template carouselSlide [width]="180">
        <div class="owl-item auto-slide-head-card">
          <div class="row content">
            <div class="col-12">
              <span class="auto-slider-heading">{{ item.label_title }}</span>
            </div>
            <div class="col-6 star-inserted-text">
              <div class="d-flex justify-content-between auto-slider-text">
                <span>{{ item.label_home }}</span
                ><span>{{ item.score_home }}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="d-flex justify-content-between auto-slider-text">
                <span>{{ item.label_away }}</span
                ><span>{{ item.score_away }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>
